<template>
    <div class="float-left" >
        <i
            class="fa fa-search-plus fa-lg icon-button"
            title="Visualizar"
            @click.stop="abrirModal()"
        ></i>
        <b-modal
            id="modalDoc"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            style="height:50%; margin: 0;"
        >
            <div slot="modal-title">
                Visualizar Documentos - {{nomeDoc}}
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
                <iframe
                    v-if="arquivo"
                    v-bind:src="arquivo"
                    style="width:100%; height:600px;"
                >
                </iframe>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConvenioServicos'

export default {
    props: {
        parentData: []
    },

    data(){
        return {
            mostrarModal: false,
            erros: [],
            arquivo: [],
            nomeDoc: ""
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true;
            this.visualizar(this.parentData);
            this.nomeDoc = this.parentData.vcNomeArquivo;
        },

        fecharModal() {
            this.mostrarModal = false;
            this.arquivo = null;
        },

        visualizar(doc){
            this.$store.dispatch('addRequest')
            ConveniosServicos.downloadDocumento(doc.id_Documento)
            .then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro na Visualização!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        let tamanho = doc.vcNomeArquivo.length
                        let tipo = doc.vcNomeArquivo.substring(tamanho-3, tamanho)

                        let typeArq = "";
                        if (tipo.toUpperCase() === "JPG"){
                            typeArq = "image/jpg"
                        }
                        else if (tipo.toUpperCase() === "PNG"){
                            typeArq = "application/png"
                        }
                        else if (tipo.toUpperCase() === "BMP"){
                            typeArq = "application/bmp"
                        }
                        else if (tipo.toUpperCase() === "PDF"){
                            typeArq = "application/pdf"
                        }
                        else if (tipo.toUpperCase() === "TML"){
                            typeArq = "text/html"
                        }
                        else if (tipo.toUpperCase() === "TXT"){
                            typeArq = "text/plain"
                        }
                        else if (tipo.toUpperCase() === "XML"){
                            typeArq = "text/xml"
                        }
                        else if (tipo.toUpperCase() === "DOC"){
                            typeArq = "application/msword"
                        }
                        else if (tipo.toUpperCase() === "OCX"){
                            typeArq = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        }
                        else if (tipo.toUpperCase() === "XLS"){
                            typeArq = "application/excel"
                        }
                        else if (tipo.toUpperCase() === "LSX"){
                            typeArq = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        }
                        else if (tipo.toUpperCase() === "RTX"){
                            typeArq = "text/richtext"
                        }
                        const blob = new Blob([response], {type: typeArq});
                        this.arquivo = window.URL.createObjectURL(blob);
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
}

</script>
